import { Helmet } from "react-helmet-async"
import Stack from "react-bootstrap/Stack"
import styles from "./styles"
import Hero from "./Hero"

export default function Instructions() {
	const schema = {
		"@context": "https://schema.org",
		"@type": "Product",
		"name": "HRA Administration Software Referral Program | Salusion",
		"description": "Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients.",
		"brand": {
			"@type": "Brand",
			"name": "Salusion"
		},
		"offers": [
			{
				"@type": "Offer",
				"name": "ICHRA",
				"description": "Individual Coverage Health Reimbursement Arrangement (ICHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "QSEHRA",
				"description": "Qualified Small Employer Health Reimbursement Arrangement (QSEHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},

		],
		"image": "https://salusion.com/assets/images/Generic.png",
		"url": "https://salusion.com",
	}
	return (
		<>
			<Helmet>
				<title>HRA Administration Software Referral Program | Salusion</title>
				<meta name="title" content="Salusion Referral Program | Earn $42 Per Participant " />
				<meta name="description" content="Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients." />
				<meta name="keywords" content="Small Business HRA administration software, ICHRA, QSEHRA, Affordable HRA, tax-free benefit" />
				<link rel="canonical" href="https://salusion.com" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@Salusion" />
				<meta name="twitter:title" content="Salusion Referral Program | Earn $42 Per Participant " />
				<meta name="twitter:description" content="Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients." />
				<meta name="twitter:image" content="https://salusion.com/assets/images/Generic.png" />

				<meta property="og:title" content="Salusion Referral Program | Earn $42 Per Participant " />
				<meta property="og:description" content="Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients." />
				<meta property="og:image" content="https://salusion.com/assets/images/Generic.png" />
				<meta property="og:image:alt" content="Salusion logo and healthcare savings" />
				<meta property="og:url" content="https://salusion.com/referral-program" />
				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Salusion" />
				<meta property="og:locale" content="en_US" />

				<script type="application/ld+json">{JSON.stringify(schema)}</script>
			</Helmet>
			<Hero />
			<section style={styles.section}>
				<div id="referral" className="container" style={styles.container}>
					<Stack gap={4} className="hra-wrapper">
						<Stack gap={3}>
							<h2 style={styles.header}>What This Is</h2>

							<p style={styles.text}>
								The Salusion Partner Platform allows you to create and
								administer HRA programs for your employer clients.
							</p>
							<p style={styles.text}>
								As a Partner, you can add employers to the platform,
								configure their HRA plan, and manage ongoing
								administration through your dashboard.
							</p>
							<p style={styles.text}>
								Each employer formally authorizes you to act on their
								behalf.
							</p>
						</Stack>

						<Stack gap={3}>
							<h2 style={styles.header}>How It Works</h2>

							<p style={styles.text}>
								{[
									"Create your Partner account",
									"Add an employer to the platform",
									"Configure and launch their HRA",
									"Manage ongoing administration",
								].map((item, i) => (
									<span key={i} style={{ display: "flex", gap: "0.5em" }}>
										<span style={{ minWidth: "1.2em", textAlign: "center" }}>{i + 1}.</span>
										<span>{item}</span>
									</span>
								))}
							</p>
							<p style={styles.text}>
								If you are a licensed broker, you may also facilitate
								employee insurance enrollment, either through
								Salusion's enrollment integration or independently.
							</p>
						</Stack>
					</Stack>
				</div>
			</section>
		</>
	)
}
